<template>
  <div :style="styles.base" @click="handleClickEvent()">
    <ceiba-payment
      :payId="configurationData.payId"
      :payInfoFlow="configurationData.payInfoFlow"
      :sellChannel="configurationData.sellChannel"
      :payBusiness="configurationData.payBusiness"
      :isUseRoleLimit="configurationData.forceRole"
      :spInfo="spInfo"
      :isBlockOrderFailAlert="!!configurationData.payFailMsg"
      @pay-success="handlePaySuccess"
      @pay-close="handlePayClose"
      @reach-limit="handleReachLimit"
      @get-pay-info="handleGetPayInfo"
      @midas-buy="handleMidasBuy"
      @query-unpaid-orders="handleQueryOrders"
      @cancel-order="handleCancelOrder"
      ref="paymentRef"
    >
    </ceiba-payment>
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <!--订单二次确认弹框-->
    <c-base-dialog
      v-model="confirmOrder"
      :option="confirmOrderDialogOption"
      @confirm="confirmOrder = false"
      @close="confirmOrder = false"
      v-transfer-dom
    >
      <template slot="body">
        <div>
          <div
            :class="getCss('msg-item')"
            v-for="(option, index) of configurationData.confirmOrderDialogContent"
            :key="index"
          >
            <span :class="getCss('msg-item-label')"
            >{{ option.label }}:</span>
            <span :class="getCss('msg-item-content')"
                  v-html="confirmOrderOption(option.content)"></span>
          </div>
        </div>
      </template>
      <template slot="fotter">
        <div>
          <button
            :style="confirmOrderButtonStyle"
            class="ceiba-base-dialog-ft-button"
            @click="toOrder()"
          >{{ confirmOrderButtonText }}
          </button>
        </div>
      </template>
    </c-base-dialog>
    <!--ios支付引导弹框-->
    <c-base-dialog v-model="isShowIosPaymentGuide" :option="iosPaymentGuideOption"
                   @close="isShowIosPaymentGuide = false"
                   @confirm="isShowIosPaymentGuide = false"
                   v-transfer-dom>
      <template slot="body">
        <div>
          <p :class="getCss('tips')"> {{ configurationData.iosPaymentGuideText }}</p>
        </div>
      </template>
      <template slot="fotter">
        <div :style="iosPaymentGuideTipStyle">
          <div :style="iosPaymentGuideTipStyle" :class="getCss('tips-action-button')">
            <button
              v-if="copyText.length > 0"
              class="ceiba-base-dialog-ft-button"
              :style="copyButtonStyle"
              @click="copyFunc()"
            >
            </button>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

const iosPaymentInApp = 1; // app内触发ios引导
const iosPaymentInQQ = 2;  // QQ客户端内触发ios引导
const iosPaymentInWx = 3; // wx客户端内触发ios引导
// const paymentModelFirstBugWithDiscount = 1;
// const paymentModelMoreBugWithDiscount = 2;
// const paymentModelMoreBugWithFixedPrice = 3;
export default {
  name: 'CPublicPayButton',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-pay-button-',
      remnantPayTimes: 1, // 剩余支付次数
      confirmOrder: false, // 订单二次确认弹框
      isShowIosPaymentGuide: false, // 显示ios支付引导
      spInfo: '', // midas券信息
      configurationDataBack: '',
    };
  },
  computed: {
    // isPaymentModelFirstBugWithDiscount() {
    //   const { paymentMode = [1, 2, 3] } = this.configurationData;
    //   return paymentMode.indexOf(paymentModelFirstBugWithDiscount) > -1;
    // },
    // isPaymentModelMoreBugWithDiscount() {
    //   const { paymentMode = [1, 2, 3] } = this.configurationData;
    //   return paymentMode.indexOf(paymentModelMoreBugWithDiscount) > -1;
    // },
    // isPaymentModelMoreBugWithFixedPrice() {
    //   const { paymentMode = [1, 2, 3] } = this.configurationData;
    //   return paymentMode.indexOf(paymentModelMoreBugWithFixedPrice) > -1;
    // },
    isMobile() {
      return common.platform.isIos || common.platform.isAndroid;
    },
    // 按钮样式
    computedStyle() {
      const { payBackgroundImage, payDoneBackgroundImage } = this.configurationData;
      console.log('computedStyle payBackgroundImage: ', payBackgroundImage);
      console.log('computedStyle payDoneBackgroundImage: ', payDoneBackgroundImage);
      return {
        cursor: 'pointer',
        position: 'static',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundImage: `url(${this.remnantPayTimes > 0 ? payBackgroundImage : payDoneBackgroundImage})`,
      };
    },
    // 二次确认弹框
    confirmOrderDialogOption() {
      return Object.assign({}, this.dialogConfig, {
        header: this.configurationData.confirmOrderDialogTitle || '订单确认',
        footer: false,
        height: this.deviceMode === 'pc' ? '660px' : '6.6rem',
        width: this.deviceMode === 'pc' ? '820px' : '7.2rem',
        dialogStyle: Object.assign({ color: '#000000' }, this.dialogConfig?.dialogStyle || {}),
      });
    },
    // 二次确认弹框下单样式
    confirmOrderButtonStyle() {
      if (this.dialogConfig?.confirmStyle?.backgroundImage) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: this.dialogConfig.confirmStyle.backgroundImage,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          // backgroundSize:'100% 100%',
          margin: '0 0',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    confirmOrderButtonText() {
      return this.dialogConfig?.confirmStyle?.backgroundImage ? '' : '确认';
    },
    isApp() {
      return this.$ast.isAPP();
    },
    //  ios 引导
    iosPaymentGuideOption() {
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    iosPaymentGuideTipStyle() {
      return {
        width: this.dialogConfig.width,
      };
    },
    // ios 复制按钮
    copyButtonStyle() {
      const { copyButtonIcon = '' } = this.configurationData;
      if (copyButtonIcon) {
        return {
          width: '2.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: `url(${copyButtonIcon})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          // backgroundSize:'100% 100%',
          margin: '0 0',
        };
      }
      return {
        width: '2.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        content: '复制链接',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        // backgroundSize:'100% 100%',
        margin: '0 0',
      };
    },
    copyText() {
      return this.configurationData.copyIosPaymentGuideText || '';
    },
  },
  watch: {
    roleInfo: {
      async handler() {
        const time = Math.floor(Math.random() * 2000) + 200;
        await this.queryIsRePay();
        await this.queryRemnantPayTimes();
        await this.doSleep(time);
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async initialize() {
      console.log('CPublicPayButton initialize', this.configurationData);
      if (this.$isInEditor) return;
      common.tool.loadScript('midas-js', 'https://midas.gtimg.cn/h5pay/js/api/midas.js', () => {
      });
      if (!this.configurationDataBack) this.configurationDataBack = JSON.stringify(this.configurationData);
      this.$refs.button.setClickHandler(this.payOrder, {
        forceLogin: true,
        forceApp: this.configurationData.forceApp,
        forceRole: this.configurationData.forceRole,
      });
      // 默认展示首购还是复购
      if (this.configurationData.isSetPreDefalutShow) this.reSetConfigurationData('payBackgroundImage', 'rePayBackgroundImage');
      if (this.configurationData.forceRole) {
        this.$onRoleReady(async () => {
          console.log('pay-button $onRoleReady');
          await this.queryIsRePay();
          await this.queryRemnantPayTimes();
        });
      } else {
        this.$onLogined(async () => {
          await this.queryIsRePay();
          await this.queryRemnantPayTimes();
        });
      }
      ;
    },
    // 下单
    async payOrder() {
      // ios 是否有配置端外引导
      const isNeedIosPaymentGuide = this.handleIosPaymentGuide();
      console.log('payOrder isNeedIosPaymentGuide', isNeedIosPaymentGuide);
      if (isNeedIosPaymentGuide === false) return false;
      const { isConfirmOrder, isForbidPayForNoCoupon } = this.configurationData;
      if (this.remnantPayTimes <= 0) return;
      await this.queryCouponList(); // 查询优惠券
      if (!!!this.spInfo && isForbidPayForNoCoupon) {
        this.$alert({ msg: '未查询到可使用的折扣优惠券' });
        return;
      }
      if (isConfirmOrder) {
        this.confirmOrder = true;
        return;
      }
      await this.toOrder();
    },
    // 支付下单 调用米大师 支付
    async toOrder() {
      if (!this.isLogin) return;
      if (this.remnantPayTimes <= 0) return;
      try {
        await this.$refs.paymentRef.buy();
      } catch (e) {
        console.error('payOrder fail, err=', e);
      }
    },
    // 支付限量
    async handleReachLimit() {
    },
    // 支付失败
    async handlePayClose() {
    },
    // 支付成功回调
    async handlePaySuccess(midasInfo) {
      console.log('handlePaySuccess midasInfo', midasInfo);
      const { paySuccessFlowId, paySuccessMsg } = this.configurationData;
      await this.refreshQua(); // 刷新礼包
      await this.queryRemnantPayTimes();
      await this.queryIsRePay();
      // 支付成功自定义提示
      if (paySuccessMsg) {
        const partitionName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
        const roleName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
        this.$alert({ msg: paySuccessMsg.replace('{{partition}}', partitionName).replace('{{role}}', roleName) });
      }
      if (paySuccessFlowId > 0) {
        await this.paySuccessCallback();
      }
      this.refreshContainerStatus();
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_callback',
        eventData: {
          pay_id: midasInfo.pay_id,
          order_id: midasInfo.order_id,
          status: '1',
        },
      });
    },
    //  存在多个预约地方的时候  同步
    refreshContainerStatus() {
      this.$eventBus.$emit('ceiba:custom:events:refresh:container:status', null);
    },
    // 执行下单逻辑
    handleGetPayInfo({ payId, response }) {
      console.log('handleGetPayInfo params', { payId, response });
      const { payFailMsg } = this.configurationData;
      const partitionName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
      const roleName = this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
      if (response.ret !== 0 && payFailMsg) {
        this.$alert({ msg: payFailMsg.replace('{{partition}}', partitionName).replace('{{role}}', roleName) });
      }
      if (response.ret === 0 && response.data.ret !== 0 && response.data.ret !== 40023 && payFailMsg) {
        this.$alert({ msg: payFailMsg.replace('{{partition}}', partitionName).replace('{{role}}', roleName) });
      }
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_makeorder',
        eventData: {
          pay_id: payId,
          status: response.ret === 0 && response.data.ret === 0 ? '1' : '0',
        },
      });
    },
    // 查询未支付的订单
    handleQueryOrders({ response }) {
      console.log('handleQueryOrders params', { response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_queryorders',
        eventData: {
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 取消订单
    handleCancelOrder({ orderId, response }) {
      console.log('handleCancelOrder params', { orderId, response });
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay_cancelorder',
        eventData: {
          order_id: orderId,
          status: response.ret === 0 ? '1' : '0',
        },
      });
    },
    // 米大师支付 (用户拉去支付)
    handleMidasBuy(midasInfo) {
      console.log('handleMidasBuy midasInfo', midasInfo);
      this.reportClickRaw({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
        eventKey: 'pay',
        eventData: {
          pay_id: midasInfo.pay_id,
          order_id: midasInfo.order_id,
          amount: midasInfo.amount,
        },
      });
    },
    // 成功回调流程
    async paySuccessCallback() {
      const { paySuccessFlowId } = this.configurationData;
      if (paySuccessFlowId <= 0) return;
      const response = await this.flowRequest({
        flowId: paySuccessFlowId,
      });
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet === 0) {
        // await this.queryRemnantPayTimes();
      } else {
        return this.$alert({ msg: resMsg || '支付失败' });
      }
    },
    // 查询剩余支付次数  没有次数就置灰 条件机输出
    async queryRemnantPayTimes() {
      const { queryRemnantPayTimesFlowId } = this.configurationData;
      if (queryRemnantPayTimesFlowId <= 0) return;
      const params = {
        flowId: queryRemnantPayTimesFlowId,
      };
      if (this.configurationData.forceRole) {
        params.params = {
          role: this.roleInfo,
        };
      }
      const response = await this.flowRequest(params);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { value = 0, ret: resRet } = data;
      if (resRet === 0) {
        this.remnantPayTimes = value;
      }
    },
    // 订单确认弹框-确认项
    confirmOrderOption(option) {
      const uinTypeName = common.platform.isWX ? '【微信账户】' : '【QQ账户】';
      switch (option) {
        case '{{role}}':
          return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.role_name || '') : '';
          break;
        case '{{partition}}':
          return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
          break;
        case '{{uin}}':
          return this.isLogin ? `<span class="csu-public-pay-button-msg-item-nick-name">${this.userInfo.nickName}</span>
            ${uinTypeName}` : `${uinTypeName}`;
          break;
        default:
          return option;
      }
    },
    reSetConfigurationData(set, get) {
      const configurationDataBackVal = JSON.parse(this.configurationDataBack);
      console.log('reSetConfigurationData configurationDataBackVal:', configurationDataBackVal);
      this.configurationData[set] = configurationDataBackVal[get];
    },
    // 查询是否复购
    async queryIsRePay() {
      const { isRePayFlow } = this.configurationData;
      if (!isRePayFlow || isRePayFlow <= 0) return;
      const params = {
        flowId: isRePayFlow,
      };
      if (this.configurationData.forceRole) {
        params.params = {
          role: this.roleInfo,
        };
      }
      const response = await this.flowRequest(params);
      console.log(`queryIsRePay ${isRePayFlow} response:`, response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { value = 0, ret: resRet } = data;
      const setValMap = {
        rePayBackgroundImage: 'payBackgroundImage',
        rePayInfoFlow: 'payInfoFlow',
        reQueryRemnantPayTimesFlowId: 'queryRemnantPayTimesFlowId',
        rePayId: 'payId',
        reConfirmOrderDialogContent: 'confirmOrderDialogContent',
        reCoupon: 'coupon',
      };
      const configurationDataBackVal = JSON.parse(this.configurationDataBack);
      if (resRet === 0 && parseInt(value, 10) === 1) {
        for (const [key, val] of Object.entries(setValMap)) {
          if (configurationDataBackVal[key]) {
            this.reSetConfigurationData(val, key);
          }
        }
      } else {
        for (const [key, val] of Object.entries(setValMap)) {
          key;
          this.reSetConfigurationData(val, val);
        }
      }
      console.log(`queryIsRePay ${isRePayFlow} configurationData:`, this.configurationData);
    },
    copyFunc() {
      const { copyIosPaymentGuideText = '' } = this.configurationData;
      if (typeof copyIosPaymentGuideText === 'string' && copyIosPaymentGuideText.length > 0) {
        const textarea = document.createElement('textarea');
        document.body.appendChild(textarea);
        textarea.style.position = 'fixed';
        textarea.style.clip = 'rect(0 0 0 0)';
        textarea.style.top = '10px';
        textarea.value = copyIosPaymentGuideText;
        textarea.select();
        document.execCommand('copy', true);
        document.body.removeChild(textarea);
        this.isShowIosPaymentGuide = false;
        this.$toast('复制成功');
      }
    },
    handleIosPaymentGuide() {
      console.log('handleIosPaymentGuide', common.platform.isIos);
      if (!common.platform.isIos) {
        return true;
      }
      const {
        iosPaymentGuideText,
        iosPaymentGuideTriggerPlace = [iosPaymentInApp, iosPaymentInQQ, iosPaymentInWx],
      } = this.configurationData;
      // 没有限制
      if (!iosPaymentGuideText) {
        return true;
      }
      // 没有限制
      if (iosPaymentGuideTriggerPlace.length === 0 || !iosPaymentGuideTriggerPlace) {
        return true;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInApp) > -1 && this.isApp) {
        this.isShowIosPaymentGuide = true;
        return false;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInQQ) > -1 && common.platform.isQQ) {
        this.isShowIosPaymentGuide = true;
        return false;
      }
      if (iosPaymentGuideTriggerPlace.indexOf(iosPaymentInWx) > -1 && common.platform.isWX) {
        this.isShowIosPaymentGuide = true;
        return false;
      }
      return true;
    },
    // 查询优惠券列表
    async queryCouponList() {
      const { queryCouponListFlow, coupon } = this.configurationData;
      this.spInfo = '';
      if (!coupon) return;
      if (!queryCouponListFlow || queryCouponListFlow <= 0) return;
      const params = {
        flowId: queryCouponListFlow,
      };
      const response = await this.flowRequest(params);
      console.log('queryCouponList response:', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg });
      }
      const { data: dataRes, ret: resRet } = data;
      if (resRet === 0 && dataRes && dataRes.length > 0) {
        for (const item of dataRes) {
          if (coupon === item.batch_id) {
            this.spInfo = `${item.code_id},${item.batch_id}`;
            return;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
